import axios from 'axios';
import React, { useState, useEffect } from 'react';
//import { Button, CloseButton, Col, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { Button, CloseButton, Col, Modal, ModalBody, ModalFooter, Tooltip } from 'reactstrap';
import { Toast, ToastBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isValidUrl } from 'app/shared/common-fun';
const DocumentUploadComponent = ({ isOpen, toggle, onDocumentUpload, achievements }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState('');
  const [imagePreview, setImagePreview] = useState('');
  const baseImageUrl = '/image';
  const [uploadedImage, setUploadedImage] = useState(null);
  const [imageName, setImageName] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [externalLink, setExternalLink] = useState('');
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);
  useEffect(() => {
    // Clear the old data when achievement changes or modal is closed
    setSelectedFile(null);
    setError('');
    setImagePreview('');
    setUploadedImage(null);
    setImageName(null);
  }, [achievements, isOpen]);

  useEffect(() => {
    if (showToast) {
      const timer = setTimeout(() => {
        setShowToast(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [showToast]);

  // const handleFileSelect = event => {
  //   const selectedFile = event.target.files[0];
  //   setSelectedFile(selectedFile);

  //   if (selectedFile && selectedFile.type === 'application/pdf') {
  //     const fileReader = new FileReader();
  //     fileReader.onload = () => {
  //       const result = fileReader.result;
  //       if (typeof result === 'string') {
  //         setImagePreview(result);
  //       }
  //     };
  //     fileReader.readAsDataURL(selectedFile);
  //   } else {
  //     setImagePreview('');
  //   }
  // };
  const handleFileSelect = event => {
    const file = event.target.files[0];
    const MAX_FILE_SIZE = 50 * 1024 * 1024;
    if (!file) {
      setSelectedFile(null);
      setImagePreview('');
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      setError('File size must be less than 50 MB.');
      setSelectedFile(null);
      setImagePreview('');
      event.target.value = '';
      return;
    }

    setSelectedFile(file);
    setError('');

    const reader = new FileReader();

    reader.onload = () => {
      if (typeof reader.result === 'string') {
        setImagePreview(reader.result);
      }
    };

    reader.onerror = () => {
      setError('Failed to preview file.');
    };

    reader.readAsDataURL(file);
  };
  // const handleFileSelect = event => {
  //   const file = event.target.files[0];

  //   if (!file) {
  //     setSelectedFile(null);
  //     setImagePreview('');
  //     return;
  //   }

  //   setSelectedFile(file);
  //   setError('');

  //   // Create preview URL for both PDF and Images
  //   const previewUrl = URL.createObjectURL(file);
  //   setImagePreview(previewUrl);
  // };

  /*const handleUpload = () => {
    if (selectedFile) {
      // Check if the file size is greater than 50MB
      if (selectedFile.size > 50 * 1024 * 1024) {
        setError('File size should be less than 50MB');
        return;
      }

      const formData = new FormData();
      formData.append('docFile', selectedFile);
      setLoading(true);
      axios
        .post(`/api/document/upload?achievement=${achievements}`, formData)
        .then(response => {
          const fullImageUrl = `${baseImageUrl}/${response.data}`;
          const fileUrl = `/doc/${response.data}`;
          setImagePreview(fullImageUrl);
          setImageName(response.data);
          setUploadedImage(response.data);
          onDocumentUpload(fileUrl);
          setError(''); // Clear any previous error

          setShowToast(true);
          //onDocumentUpload(selectedFile); // Call the parent component's function to handle document upload
          toggle(); // Close the modal on success
        })
        .catch(error => {
          console.error('Error uploading pdf:', error);
          setError('Error uploading pdf. Please try again.'); // Set an appropriate error message
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };*/

  const handleUpload = () => {
    if (achievements === 'KindnessAct' || selectedFile) {
      if (!selectedFile && !externalLink.trim()) {
        setError('Please upload a file or provide an external link.');
        return;
      }
      if (externalLink.trim()) {
        if (!isValidUrl(externalLink.trim())) {
          return;
        }
      }
      // Check if the file size is greater than 50MB
      if (selectedFile && selectedFile.size > 50 * 1024 * 1024) {
        setError('File size should be less than 50MB');
        return;
      }
      const formData = new FormData();
      if (selectedFile) {
        formData.append('docFile', selectedFile);
      }

      if (externalLink) {
        formData.append('externalLink', externalLink || '');
      }
      setLoading(true);
      axios
        .post(`/api/document/upload?achievement=${achievements}`, formData)
        .then(response => {
          const fullImageUrl = `${baseImageUrl}/${response.data}`;
          const fileUrl = `/doc/${response.data}`;
          setImagePreview(fullImageUrl);
          setImageName(response.data);
          setUploadedImage(response.data);
          onDocumentUpload(fileUrl);
          setError(''); // Clear any previous error

          setShowToast(true);
          //onDocumentUpload(selectedFile); // Call the parent component's function to handle document upload
          toggle(); // Close the modal on success
        })
        .catch(error => {
          console.error('Error uploading pdf:', error);
          setImagePreview('');
          if (achievements === 'KindnessAct') {
            setError('Only PDF, JPG, JPEG and PNG files are allowed.');
          } else {
            setError('Only PDF files are allowed.');
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const handleRemoveImage = () => {
    setImagePreview('');
    setUploadedImage(null);
    setImageName('');
    setSelectedFile('');
  };

  return (
    <>
      <Modal
        className="beautiful-upload-modal"
        isOpen={isOpen}
        toggle={!loading ? toggle : undefined}
        backdrop={loading ? 'static' : true}
        keyboard={!loading}
        centered
      >
        <ModalBody className="p-4">
          {/* Header */}
          <div className="upload-header mb-4 text-center ">
            <p className="text-muted small">
              {achievements === 'KindnessAct'
                ? 'Upload a supporting document, image, or provide a valid link (any one option)'
                : 'Upload a supporting document'}
            </p>
          </div>

          {/* Upload Box */}
          <div className="upload-box mb-3">
            <input
              id="uploadFileInput"
              type="file"
              accept={achievements === 'KindnessAct' ? 'application/pdf,image/*' : 'application/pdf'}
              onChange={handleFileSelect}
              disabled={externalLink.trim() !== ''}
              className="file-input"
            />
            <div className="upload-content text-center">
              <FontAwesomeIcon icon="upload" size="2x" className="mb-2 text-primary" />
              <p className="mb-1 fw-semibold">Click or Drag file to upload</p>
              <small className="text-muted">Max size 50MB</small>
            </div>
          </div>

          <Tooltip placement="top" isOpen={tooltipOpen} target="uploadFileInput" toggle={toggleTooltip}>
            You can upload only one document in 24 hours.
          </Tooltip>

          {/* External Link */}
          {achievements === 'KindnessAct' && (
            <div className="mt-3">
              <label className="form-label fw-semibold">Or Add External Link</label>
              <input
                type="url"
                placeholder="https://example.com"
                // className="form-control modern-input"
                value={externalLink}
                disabled={!!selectedFile}
                className={`form-control modern-input ${externalLink && !isValidUrl(externalLink) ? 'is-invalid' : ''}`}
                onChange={e => {
                  setExternalLink(e.target.value);
                  setSelectedFile(null);
                  setError('');
                }}
              />
            </div>
          )}
          {externalLink && !isValidUrl(externalLink) && (
            <div className="invalid-feedback d-block">Please enter a valid URL (http:// or https:// required)</div>
          )}

          {error && <div className="alert alert-danger mt-3 py-2 text-center">{error}</div>}

          {/* Preview */}
          {/* {imagePreview && (
            <div className="preview-container mt-4 position-relative">
              <CloseButton className="preview-close" onClick={handleRemoveImage} />
              <embed className="preview-embed" src={imagePreview} width="100%" height="350px" type="application/pdf" />
            </div>
          )} */}

          {imagePreview && (
            <div className="preview-container mt-4 position-relative">
              <CloseButton className="preview-close" onClick={handleRemoveImage} />

              {selectedFile?.type?.includes('pdf') ? (
                <embed className="preview-embed" src={imagePreview} width="100%" height="350px" type="application/pdf" />
              ) : (
                <img src={imagePreview} alt="Preview" style={{ width: '100%', maxHeight: '350px', objectFit: 'contain' }} />
              )}
            </div>
          )}

          {/* Upload Button */}
          <div className="text-center mt-4">
            <Button
              color="primary"
              className="px-5 py-2"
              onClick={handleUpload}
              disabled={loading || (achievements === 'KindnessAct' ? !selectedFile && !externalLink.trim() : !selectedFile)}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" />
                  Uploading...
                </>
              ) : (
                'Upload'
              )}
            </Button>
          </div>
        </ModalBody>
      </Modal>
      {showToast && (
        <div className="position-fixed top-0 end-0 p-4" style={{ zIndex: 2000 }}>
          <Toast isOpen={showToast} fade className="border-0 shadow-lg rounded-4">
            <ToastBody className="d-flex align-items-center">
              <div
                className="bg-primary bg-opacity-10 text-success rounded-circle d-flex align-items-center justify-content-center me-3"
                style={{ width: '45px', height: '45px' }}
              >
                <FontAwesomeIcon icon="check-circle" size="lg" />
              </div>

              <div>
                <div className="fw-semibold text-dark">Successful</div>
                <small className="text-muted">Your data has been submitted successfully.</small>
              </div>
            </ToastBody>
          </Toast>
        </div>
      )}
    </>
  );
};

export default DocumentUploadComponent;
